import { useCallback, useMemo, useReducer } from "react";

import { initialState } from "./initialState";
import { getActiveCallsViewModel } from "../utils";
import { ActiveCallActions } from "./action";
import reduceActiveCalls from "./reducer";

export default function useActiveCallsStore() {
  const [state, dispatch] = useReducer(reduceActiveCalls, initialState);

  const updateActiveCallStats = useCallback(function (state) {
    const callQueueStateViewModel = getActiveCallsViewModel(state);
    dispatch({
      type: ActiveCallActions.SET_STATE,
      payload: callQueueStateViewModel,
    });
  }, []);

  const updateIsLoading = useCallback(function (isLoading) {
    dispatch({
      type: ActiveCallActions.SET_LOADING,
      payload: { isLoading },
    });
  }, []);

  const value = useMemo(
    function () {
      return {
        state,
        updateActiveCallStats,
        updateIsLoading,
      };
    },
    [state, updateActiveCallStats, updateIsLoading]
  );

  return value;
}
